import { css as v, LitElement as g, html as n, nothing as c } from "lit";
import { property as a, customElement as u } from "lit/decorators.js";
import { classMap as f } from "lit/directives/class-map.js";
import { b as m } from "./styles-scZ6dVz-.js";
import { b as d, a as h } from "./events-CkEPl0SM.js";
var k = Object.defineProperty, y = Object.getOwnPropertyDescriptor, o = (r, l, s, t) => {
  for (var i = t > 1 ? void 0 : t ? y(l, s) : l, p = r.length - 1, b; p >= 0; p--)
    (b = r[p]) && (i = (t ? b(l, s, i) : b(i)) || i);
  return t && i && k(l, s, i), i;
};
let e = class extends g {
  constructor() {
    super(...arguments), this.variant = "default", this.size = "md", this.removable = !1, this.clickable = !1, this.selectable = !1, this.selected = !1, this.disabled = !1;
  }
  handleClick() {
    this.disabled || (this.selectable ? (this.selected = !this.selected, d(this, h.SELECT, { selected: this.selected, value: this.value })) : this.clickable && d(this, h.CLICK, { value: this.value }));
  }
  handleRemove(r) {
    r.stopPropagation(), !this.disabled && d(this, h.REMOVE, { value: this.value });
  }
  handleKeydown(r) {
    this.disabled || ((r.key === "Enter" || r.key === " ") && (r.preventDefault(), this.handleClick()), (r.key === "Delete" || r.key === "Backspace") && this.removable && (r.preventDefault(), d(this, h.REMOVE, { value: this.value })));
  }
  render() {
    const r = {
      chip: !0,
      [this.variant]: !0,
      [this.size]: !0,
      clickable: this.clickable || this.selectable,
      selectable: this.selectable,
      selected: this.selected,
      disabled: this.disabled
    }, l = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `, s = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
    `, t = this.clickable || this.selectable;
    return n`
      <span
        part="chip"
        class=${f(r)}
        role=${this.selectable ? "option" : t ? "button" : c}
        tabindex=${t && !this.disabled ? "0" : c}
        aria-selected=${this.selectable ? String(this.selected) : c}
        aria-disabled=${this.disabled ? "true" : c}
        @click=${this.handleClick}
        @keydown=${this.handleKeydown}
      >
        <span part="avatar" class="avatar">
          <slot name="avatar"></slot>
        </span>

        ${this.selectable ? n`<span class="check-icon">${s}</span>` : c}

        <span part="content" class="content">
          <slot></slot>
        </span>

        ${this.removable && !this.disabled ? n`
              <button
                part="remove"
                class="remove"
                type="button"
                aria-label="Remove"
                @click=${this.handleRemove}
              >
                ${l}
              </button>
            ` : c}
      </span>
    `;
  }
};
e.styles = [
  m,
  v`
      :host {
        display: inline-flex;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .chip {
        display: inline-flex;
        align-items: center;
        gap: var(--r5-space-1-5);
        font-family: var(--r5-font-body);
        font-weight: var(--r5-font-medium);
        border-radius: var(--r5-radius-full);
        white-space: nowrap;
        line-height: 1;
        border: 1px solid transparent;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        cursor: default;
      }

      /* Sizes */
      .sm {
        height: 1.5rem;
        padding: 0 var(--r5-space-2);
        font-size: var(--r5-text-xs);
      }

      .md {
        height: 2rem;
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      .lg {
        height: 2.5rem;
        padding: 0 var(--r5-space-4);
        font-size: var(--r5-text-base);
      }

      /* Variants */
      .default {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
        border-color: var(--r5-border);
      }

      .primary {
        background-color: var(--r5-color-primary-100);
        color: var(--r5-color-primary-700);
        border-color: var(--r5-color-primary-200);
      }

      .success {
        background-color: var(--r5-color-success-100);
        color: var(--r5-color-success-700);
        border-color: var(--r5-color-success-200);
      }

      .warning {
        background-color: var(--r5-color-warning-100);
        color: var(--r5-color-warning-700);
        border-color: var(--r5-color-warning-200);
      }

      .danger {
        background-color: var(--r5-color-danger-100);
        color: var(--r5-color-danger-700);
        border-color: var(--r5-color-danger-200);
      }

      .info {
        background-color: var(--r5-color-info-100);
        color: var(--r5-color-info-700);
        border-color: var(--r5-color-info-200);
      }

      /* Interactive states */
      .clickable {
        cursor: pointer;
      }

      .clickable:hover {
        filter: brightness(0.95);
      }

      .clickable:active {
        filter: brightness(0.9);
      }

      .clickable:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      /* Selectable */
      .selectable {
        cursor: pointer;
      }

      .selectable:not(.selected) {
        background-color: var(--r5-bg-muted);
        border-color: var(--r5-border);
        color: var(--r5-text-muted);
      }

      .selectable:not(.selected):hover {
        background-color: var(--r5-bg-subtle);
        color: var(--r5-text);
      }

      .selected {
        background-color: var(--ark-chip-bg, var(--r5-color-primary-100));
        border-color: var(--ark-chip-ring, var(--r5-color-primary-200));
        color: var(--ark-chip-color, var(--r5-color-primary-700));
      }

      .selected:hover {
        filter: brightness(0.95);
      }

      /* Color variants for selected state */
      :host([color='blue']) { --ark-chip-bg: #dbeafe; --ark-chip-color: #1d4ed8; --ark-chip-ring: #bfdbfe; }
      :host([color='amber']) { --ark-chip-bg: #fef3c7; --ark-chip-color: #b45309; --ark-chip-ring: #fde68a; }
      :host([color='red']) { --ark-chip-bg: #fee2e2; --ark-chip-color: #b91c1c; --ark-chip-ring: #fecaca; }
      :host([color='neutral']) { --ark-chip-bg: #e4e4e7; --ark-chip-color: #3f3f46; --ark-chip-ring: #d4d4d8; }
      :host([color='emerald']) { --ark-chip-bg: #d1fae5; --ark-chip-color: #047857; --ark-chip-ring: #a7f3d0; }

      @media (prefers-color-scheme: dark) {
        :host([color='blue']) { --ark-chip-bg: rgba(59, 130, 246, 0.2); --ark-chip-color: #93c5fd; --ark-chip-ring: rgba(59, 130, 246, 0.3); }
        :host([color='amber']) { --ark-chip-bg: rgba(245, 158, 11, 0.2); --ark-chip-color: #fcd34d; --ark-chip-ring: rgba(245, 158, 11, 0.3); }
        :host([color='red']) { --ark-chip-bg: rgba(239, 68, 68, 0.2); --ark-chip-color: #fca5a5; --ark-chip-ring: rgba(239, 68, 68, 0.3); }
        :host([color='neutral']) { --ark-chip-bg: rgba(113, 113, 122, 0.3); --ark-chip-color: #d4d4d8; --ark-chip-ring: rgba(113, 113, 122, 0.4); }
        :host([color='emerald']) { --ark-chip-bg: rgba(16, 185, 129, 0.2); --ark-chip-color: #6ee7b7; --ark-chip-ring: rgba(16, 185, 129, 0.3); }
      }

      /* Disabled */
      .disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }

      /* Avatar slot */
      .avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: calc(-1 * var(--r5-space-1));
      }

      .sm .avatar {
        width: 1rem;
        height: 1rem;
      }

      .md .avatar {
        width: 1.25rem;
        height: 1.25rem;
      }

      .lg .avatar {
        width: 1.5rem;
        height: 1.5rem;
      }

      .avatar ::slotted(*) {
        width: 100%;
        height: 100%;
        border-radius: var(--r5-radius-full);
        object-fit: cover;
      }

      /* Content */
      .content {
        display: inline-flex;
        align-items: center;
      }

      /* Remove button */
      .remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: var(--r5-space-0-5);
        margin-right: calc(-1 * var(--r5-space-1));
        border: none;
        background: transparent;
        color: currentColor;
        opacity: 0.7;
        cursor: pointer;
        border-radius: var(--r5-radius-full);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .remove:hover {
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .selected .remove:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }

      .remove svg {
        width: 0.75em;
        height: 0.75em;
      }

      .sm .remove svg {
        width: 0.625rem;
        height: 0.625rem;
      }

      .md .remove svg {
        width: 0.75rem;
        height: 0.75rem;
      }

      .lg .remove svg {
        width: 0.875rem;
        height: 0.875rem;
      }

      /* Check icon for selected state */
      .check-icon {
        display: none;
        margin-left: calc(-1 * var(--r5-space-1));
      }

      .selected .check-icon {
        display: flex;
      }

      .check-icon svg {
        width: 0.875em;
        height: 0.875em;
      }

      @media (prefers-reduced-motion: reduce) {
        .chip {
          transition: none;
        }
      }
    `
];
o([
  a({ type: String, reflect: !0 })
], e.prototype, "variant", 2);
o([
  a({ type: String, reflect: !0 })
], e.prototype, "size", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "removable", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "clickable", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "selectable", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "selected", 2);
o([
  a({ type: Boolean, reflect: !0 })
], e.prototype, "disabled", 2);
o([
  a({ type: String })
], e.prototype, "value", 2);
o([
  a({ type: String, reflect: !0 })
], e.prototype, "color", 2);
e = o([
  u("ark-chip")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-chip-B3XVsE-7.js.map
